import React from "react";
import {
  Box,
  Checkbox,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const StatusCheckboxFilter = ({ column }) => {
  //const { filterValue = [], setFilter, preFilteredRows, id } = column;
  const [anchorEl, setAnchorEl] = React.useState(null);
const { filterValue = [], setFilter, preFilteredRows, id, filterHiddenOptions = [] } = column;
  // Get all unique status options from the data
const statusOptions = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      if (row.values[id]) {
        options.add(row.values[id]);
      }
    });
    return Array.from(options)
      .filter((opt) => !filterHiddenOptions.includes(opt)) // 👈 hide custom options
      .sort();
  }, [id, preFilteredRows, filterHiddenOptions]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (option, isChecked) => {
    setFilter((prev) => {
      if (isChecked) {
        return [...(prev || []), option];
      } else {
        return (prev || []).filter((v) => v !== option);
      }
    });
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          padding: "4px",
          color: filterValue.length > 0 ? "primary.main" : "inherit",
          '&:hover': {
            // Set hover styles to match default state
            color: filterValue.length > 0 ? "primary.main" : "inherit",
            backgroundColor: 'transparent', // If you want to disable background color change on hover
            // Add any other properties you want to remain unchanged on hover
          }
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography
            sx={{
              opacity: 1,
              color: "#7A7A7A",
              fontSize: "0.9rem",
            }}
          >
            Status
          </Typography>
          <FilterListIcon fontSize="small" />
        </Box>
        {filterValue.length > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              width: 8,
              height: 8,
              bgcolor: "primary.main",
              borderRadius: "50%",
            }}
          />
        )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            maxHeight: 300,
            width: 200,
          },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            px: 2,
            py: 1,
            fontWeight: "bold",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          Filter by Status
        </Typography>

        {statusOptions.map((option, i) => (
          <MenuItem key={i} onClick={(e) => e.stopPropagation()}>
            <ListItemIcon>
              <Checkbox
                checked={filterValue.includes(option)}
                onChange={(e) => handleChange(option, e.target.checked)}
                size="small"
                color="primary"
              />
            </ListItemIcon>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default StatusCheckboxFilter;
